<template>
    <div class="mak-kontrol-gecmisi-page">
        <el-page-header
            @back="goBack"
            title="Geri"
            content="Kontrol Geçmişi">

        </el-page-header>

        <el-row type="flex" justify="space-between" align="center">
            <div>
                <el-button icon="el-icon-arrow-left" @click="change(-1)"></el-button>
            </div>
            <div>
                <el-date-picker
                    v-model="date"
                    format="dd/MM/yyyy"
                    :picker-options="{
                            disabledDate
                        }"
                />
            </div>
            <div>
                <el-button icon="el-icon-arrow-right" @click="change(1)"></el-button>
            </div>
        </el-row>

        <el-table
            v-loading="loading"
            :data="data">

            <el-table-column type="expand" width="30">
                <template slot-scope="{ row }">
                    <el-row type="flex" justify="space-between">
                        <div>
                            <p><b>Tahsilat Tutarı:</b> {{row.tahsilat_tutari}}</p>
                            <p><b>Dolum Yapıldı mı?:</b> {{row.dolum_yapildi === '1' ? 'Yapıldı' : 'Yapılmadı'}}</p>
                            <p><b>Not:</b> {{row.not}}</p>
                        </div>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column type="index"/>
            <el-table-column label="Musteri" prop="sirket_adi" sortable/>
            <el-table-column
                prop="kontrol_zamani"
                label="Kontrol zamanı"
                :formatter="formatDateTimeCol"></el-table-column>
            <el-table-column>
                <template slot-scope="{ row }">
                    <el-button icon="el-icon-refresh" @click="change(row)">Değiştir</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import Formatter from '@/mixins/Formatter.js';
    import moment from 'moment';

    export default {
        name: 'mak-kontrol-gecmisi-page',
        mixins: [Formatter],
        data()  {
            return {
                loading: false,
                data: [],
                date: moment(),
                lastFetched: null,
            };
        },
        computed: {
            dateStr() {
                return moment(this.date).format('YYYY-MM-DD');
            },
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            disabledDate(time) {
                return time.getTime() > Date.now();
            },
            change(n) {
                this.date = moment(this.date).add(n, 'days');
            },
            fetch() {
                if (this.lastFetched === this.dateStr) {
                    return;
                }
                this.lastFetched = this.dateStr;

                this.loading = true;
                this.$requests.MusteriKontrol
                    .getMusteriKontrolGun(this.dateStr)
                    .then((data) => {
                        this.data = (data || []);
                    })
                    .catch((error) => {
                        console.error(`error on loading getMusteriKontrolGun`, error);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
        mounted() {
            this.fetch();
        },
        watch: {
            dateStr() {
                this.fetch();
            },
        }
    }
</script>

<style lang="scss">
    .mak-kontrol-gecmisi-page {
        .el-page-header__content {
            width: 100%;
        }
    }
</style>
